import { render, staticRenderFns } from "./LabelModal6a4.vue?vue&type=template&id=f229ec16&scoped=true&"
import script from "./LabelModal6a4.vue?vue&type=script&lang=js&"
export * from "./LabelModal6a4.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal6a4.vue?vue&type=style&index=0&id=f229ec16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f229ec16",
  null
  
)

export default component.exports